$(function(){
  $(document).on('click','.u_pro_meta_video_wrapper',function(){
    $('html').addClass('u_video_overflow')
    $('.shopify-section--announcement-bar').addClass('u_sticky_bar')
      $('.u_pro_meta_video_block video').get(0).play() 
    $('#superchat-widget').addClass('u_chat')
    $('.u_pro_meta_video_popup_block').show()
  })
  $(document).on('click','.u_pro_meta_video_cross',function(){
    $('html').removeClass('u_video_overflow')
    $('.shopify-section--announcement-bar').removeClass('u_sticky_bar')
      $('.u_pro_meta_video_block video').get(0).pause() 
    $('#superchat-widget').removeClass('u_chat')
       $('.u_pro_meta_video_popup_block').hide()
  })
  $(document).on('click','.u_custom_info_block2',function(e){
      console.log("clickclicklcick");
    $('.u_custom_info_block').toggleClass('u_text_open')
  })
     $(document).on('click','.u_custom_info_block',function(e){
    console.log('stop propagation')    
    e.stopPropagation();
  }) 
      $(document).on("click","body",function(e){
    console.log('body click')
             $('.u_custom_info_block').removeClass('u_text_open')
  });

})